module.exports = __webpack_public_path__ + "statics/img/FeaturedCases-2.aa0c54be.png";